const ResourceActions = Vue.component('resource-actions', {
	props: {
		resource: Object | Array,
	},
	data() {
		return {
			hasDownload: this.resource.post_type !== 'video' && this.resource.file ? true : false,
			hasVideo: this.resource.post_type === 'video' && this.resource.hasVideo ? true : false,
			hasShare: this.resource.file ? true : false,
		};
	},
	computed: {
		hasAnyAction() {
			return this.hasDownload || this.hasVideo || this.hasShare;
		},
	},
	template: '#pst-product-resource-actions',
});

const ResourceFilters = Vue.component('resource-filters', {
	props: {
		initialFilters: Object | Array,
	},
	data() {
		return {
			filters: this.initialFilters,
			typeChanged: [false, false, false],
		};
	},
	methods: {
		modifyPlaceholder(i) {
			this.typeChanged[i] = true;
		},
	},
	template: '#pst-product-resource-filters',
});

export const PXProductResourceSearch = (function () {
	'use strict';

	let app;

	function init() {
		if (!document.getElementById('poly-product-resource-search')) return;

		app = new Vue({
			el: '#poly-product-resource-search',
			components: { ResourceActions, ResourceFilters },
			data() {
				return {
					query: '',
					products: [],
					selectedProduct: {},
					activeFilters: [],
					movePlaceholder: false,
					isFetching: false,
				};
			},
			created() {
				let queryParams = PixelsmithModules.Helpers.getUrlParams(window.location.search);

				if (queryParams.productresourcequery) {
					this.query = queryParams.productresourcequery;
					this.movePlaceholder = true;
					this.focusSearchInput();
				}
			},
			mounted() {
				this.fetchProducts();
			},
			methods: {
				resetResourceFilter(filter) {
					let resourceFiltersEl = $('.pxblock--product-resource-search__filters');
					resourceFiltersEl.find('select').each(function () {
						$(this).val('');
					});
					let resourceForm = $('.resource_search_form');
					resourceForm.removeClass('placeholderMoved');
					if (window.location.href.indexOf('?') > -1) {
						history.pushState({}, document.title, window.location.pathname);
					}
					this.query = '';
					this.selectedProduct = {};
					this.filterUpdateHandler([]);
					setTimeout(function () {
						resourceForm.find('input').val('');
						resourceForm.find('button').trigger('click');
					}, 100);
				},
				filterUpdateHandler(newFilters) {
					this.activeFilters = newFilters
						.filter((f) => {
							return f.activeTerm !== '';
						})
						.map((f) => {
							return '' + f.activeTerm;
						});
				  
					const productsArr = Object.values(this.products);
				  
					if (this.activeFilters.length === 0)
						return productsArr.forEach((p) => (p.hidden = false));
				  
					productsArr.forEach((p) => {
						p.hidden = !this.activeFilters.every(filter => p.termSlugs.includes(filter));
					});
				  },
				showModal(content) {
					document.getElementById('polywater-modal-content').innerHTML =
						'<div class="responsive-video">' + content + '</div>';
					MicroModal.show('polywater-modal');
				},
				shareFile(file) {
					let attachmentsEl = document.getElementById(
						'polywater-modal-share-attachments'
					);
					let filenameEl = document.getElementById('polywater-modal-share-filename');
					let attachmentInput = document.createElement('input');

					attachmentInput.setAttribute('type', 'hidden');
					attachmentInput.setAttribute('name', 'attachments[]');
					attachmentInput.value = file.ID;

					filenameEl.innerText = file.filename;
					attachmentsEl.appendChild(attachmentInput);

					let shareForm = document.getElementById('polywater-modal-share-form');
					let shareMessage = document.getElementById('polywater-modal-share-form-message');
					let emailInput = document.getElementById('polywater-modal-share-email');
					let msgInput = document.getElementById('polywater-modal-share-message');
					let submitBtn = document.getElementById('polywater-modal-share-submit');

					emailInput.value = '';
					msgInput.value = '';

					shareForm.style.display = 'block';
					shareMessage.style.display = 'none';
					submitBtn.removeAttribute('disabled');

					MicroModal.show('polywater-modal-share');
				},
				fetchProducts($ev) {
					if ($ev) $ev.preventDefault();
					this.isFetching = true;
					let queryParams = PixelsmithModules.Helpers.getUrlParams(
						window.location.search
					);
					if (this.query !== '' && PXIsAdmin['admin'] !== 'true') {
						history.pushState(
							{ productresourcequery: this.query },
							'New product resource query: ${this.query}',
							`?productresourcequery=${this.query}`
						);
					}

					let postData = {
						s: this.query,
					};

					if (queryParams.lang) postData.lang = queryParams.lang;

					postData.isResource = '1';
					postData.currentSiteLanguage = PXConstants.current_site_language;
					const searchParams = new URLSearchParams(postData).toString();

					axios
						.get(`/wp-json/wp/v2/productsearch?${searchParams}`)
						.then((response) => {
							this.products = response.data;
						})
						.catch((error) => console.log(error))
						.finally(() => {
							this.isFetching = false;
						});
				},
				focusSearchInput() {
					this.movePlaceholder = true;
				},
				togglePlaceholder(e) {
					const eventValue = e.target.value;
					this.movePlaceholder = !this.movePlaceholder;

					if (eventValue.length) {
						this.movePlaceholder = true;
					}
				},
				handleOnProductClick(product) {
					this.selectedProduct = product;
					const DOMBody = document.body;
					MicroModal.show('polywater-modal-product-resources-mobile', {
						awaitCloseAnimation: true,
						onShow: function () {
							DOMBody.classList.add('product-resources-modal--is-open');
						},
						onClose: function () {
							DOMBody.classList.remove('product-resources-modal--is-open');
						},
					});
				},
				handleMobileModalClose() {
					MicroModal.close('polywater-modal-product-resources-mobile');
				},
				stripTags(input) {
					return input.replace(/<[^>]*>?/gm, '');
				},
		  	},
		});
	}

	return {
		init: init,
	};
})();
